module.exports = __webpack_public_path__ + "img/eqHeader3.8739c3bc.png";